import { render } from "./YearOverYearIncomeWidget.vue?vue&type=template&id=716edbaf"
import script from "./YearOverYearIncomeWidget.vue?vue&type=script&lang=js"
export * from "./YearOverYearIncomeWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__